.fp-icon-with-text(data-test='live-auction-footer')
  .fp-dot
  .fp-icon-with-text--text
    .fp-icon-with-text--text-line
      .fp-text.-text-xs {{ t('marketplace.auction.expiresIn') }}
    .fp-icon-with-text--text-line
      code.fp-text.-text-xs.-text-semi-bold {{ countdownBeforeEndDate.daysLeft + t('countdown.shortDays') }} {{ countdownBeforeEndDate.hoursLeft + t('countdown.shortHours') }} {{ countdownBeforeEndDate.minutesLeft + t('countdown.shortMinutes') }} {{ countdownBeforeEndDate.secondsLeft + t('countdown.shortSeconds') }}
